export default "__VITE_ASSET__Bg8Rrbw0__"